<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-16 17:25:24
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:04:34
 * @name: 添加琴行
 * @Description: 商品添加琴行
 * @FilePath: \preSaleNafterSaleBackstage\src\components\waresGoodsManage\dialog\add-piano-company.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <addNeditDialog ref="addNeditDialog" title="添加琴行" @close="close">
    <template v-slot:form>
      <el-select value="" placeholder="请选择琴行" @change="selectPianoCompany">
        <el-option
          v-for="item of pianoCompanyList"
          :key="item.id"
          :label="item.agency_name"
          :value="item"
        ></el-option>
      </el-select>
      <div class="list">
        <div
          class="item"
          v-for="item of waresGoods.allPianoComponey"
          :key="item.id"
        >
          <font>{{ item | agencyNameFilter }}</font>
          <i class="el-icon-close" @click="deletePianoCompany(item.id)"></i>
        </div>
      </div>
    </template>
    <template v-slot:btnGroup>
      <el-button type="primary" @click="submit()">确认</el-button>
    </template>
  </addNeditDialog>
</template>
<script>
import addNeditDialog from "./addNeditDialog";
import pianoCompany from "@/object/pianoCompany/pianoCompany.class.js";
import { confirmation, debounceation } from "@/utils/decorator";

export default {
  name: "waresGoodsManage-addPianoCompany",
  components: {
    addNeditDialog,
  },
  props: {
    waresGoods: {
      type: Object,
    },
  },
  data() {
    return {
      pianoCompany: new pianoCompany(),
      id: "", //商品id
      goods_sku_id: "", //商品sku_id
      level: "", //商品级别
      updated: "", //有过更改
    };
  },
  computed: {
    // 可选的琴行列表
    pianoCompanyList() {
      return (
        this.pianoCompany?.options_pianoCompany.filter(
          (x) =>
            this.waresGoods.allPianoComponey.findIndex(
              (y) => y?.agency?.id === x.id
            ) === -1
        ) ?? []
      );
    },
  },
  filters: {
    agencyNameFilter(e) {
      return e?.agency?.agency_name ?? "";
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {Object} row 商品级别行数据
     */
    open(row) {
      this.id = row.id;
      this.goods_sku_id = row.goods_sku_id;
      this.level = row.level;
      this.updated = false;
      this.waresGoods.allPianoComponey = [];
      this.getOptionsPianoCompany();
      this.waresGoods.agencyGoodsGetAllList({ goods_level_id: this.id });
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗回调
     */
    close() {
      this.updated && this.$emit("editAllPianoCompanyHandler"); //有过变更,刷新父组件
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击确认
     */
    @debounceation(300)
    submit() {
      this.cancel();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取琴行列表
     */
    getOptionsPianoCompany() {
      const loading = this.$commonUtil.loading("查询琴行列表中...");
      this.pianoCompany.getOptionsPianoCompany().finally(() => {
        loading.close();
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 删除琴行
     * @param {Number} id 琴行id
     */
    @confirmation("确认删除该琴行?")
    deletePianoCompany(id) {
      this.waresGoods
        .deletePianoCompany({ agency_goods_id: id })
        .then((res) => {
          this.waresGoods.agencyGoodsGetAllList({ goods_level_id: this.id });
          this.updated = true;
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 选择琴行
     * @param {Object} e 选择项数据
     */
    selectPianoCompany(e) {
      this.waresGoods
        .addPianoCompany({
          goods_level_id: Number(this.id),
          goods_sku_id: Number(this.goods_sku_id),
          level: Number(this.level),
          agency_ids: String(e.id),
        })
        .then((res) => {
          this.waresGoods.agencyGoodsGetAllList({ goods_level_id: this.id });
          this.updated = true;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-select {
  width: 300px;
  margin-bottom: 20px;
  align-self: flex-start;
}
.list {
  width: 240px;
  max-height: 300px;
  align-self: flex-start;
  overflow-y: auto;
  display: grid;
  @include grid-row(auto, auto, 5px);
  .item {
    box-sizing: border-box;
    padding: 5px 10px;
    background: $Vars-background-single-gray;
    border-radius: $Vars-border-radius-normal;
    @extend .extend-flex-spacebetween;
    & * {
      opacity: 1;
    }
    i {
      font-size: $Vars-font-secondary-size;
      &:hover {
        @extend .extend-clickElement;
      }
    }
  }
}
.el-button {
  margin-left: 40px;
  width: $Var-button-width-normal;
  &:first-child {
    margin-left: 0;
  }
}
</style>
